export enum SchedulePeriod {
	ONLY_ONCE = 'once',
	DAILY = 'daily',
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
}
